import React from 'react';
import { SideBar } from './sidebar';
import i18n from '../../i18n';
import Chart from 'react-apexcharts';
import { getAuctionChartData, getSalesChartData } from '../../models/auctions';
import { getUserChartData } from '../../models/users';
import { getDashboardData } from '../../models/dashboard';
import { Spinner } from 'react-bootstrap';
import { getLoggedUser } from '../../state/user';
import { HomeBanner } from '../home/homeBanner';
import ProjectCard from '../common/ProjectCard';
import { CalendarCheck, Clock, ShieldCheck } from 'lucide-react';
import HeaderBanner from '../common/HeaderBanner';

const user = getLoggedUser();

export class DashboardAuctionEvaluation extends React.Component {
  constructor() {
    super();
    this.state = {
      first_panel: true,
      second_panel: true,
      third_panel: false,
      forth_panel: false,
      input: {},
      is_loading_1: false,
      is_loading_2: false,
      is_loading_3: false,
      is_loading_4: false,
      main_auctions: [],
      charity_auctions: [],
      auctions: {
        series: [0, 0, 0, 0, 0],
        options: {
          chart: {
            height: 350,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '70%',
              },
            },
          },
          labels: [
            i18n.t('active'),
            i18n.t('upcoming'),
            i18n.t('previous'),
            i18n.t('featured'),
            i18n.t('direct'),
          ],
          legend: {
            show: true,
            position: 'bottom',
          },
        },
      },
      charity: {
        series: [0, 0, 0, 0, 0],
        options: {
          chart: {
            height: 350,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '100%',
              },
            },
          },
          labels: ['Active', 'Upcoming', 'Previous', 'Featured', 'Direct'],
          legend: {
            show: true,
            position: 'bottom',
          },
        },
      },
      userData: 'monthly',
      daily: {},
      monthly: {},
      salesData: 'monthly',
      yearlySales: {},
      monthlySales: {},
      active_auctions: 0,
      active_bidders: 0,
      total_bidders: 0,
      total_bids: 0,
      maximum_bid_amount: 0,
      total_amount: 0,
      auction_in_bidding: 0,
      dd_loading: false,
      group: false,
      is_side_bar: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.loadDashboardData = this.loadDashboardData.bind(this);
    this.hideSideBar = this.hideSideBar.bind(this);
  }

  componentDidMount() {
    this.loadAuctionsData();
    this.loadCharityAuctionsData();
    this.loadUserChartData();
    this.loadSalesChartData();
    if (user.role === 'A' || user.role === 'M') {
      setInterval(this.loadDashboardData, 10000);
    }
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  async loadDashboardData(data = false) {
    this.setState({ dd_loading: true });
    let { group, auction } = data;
    let input = this.state.input;
    input.group = typeof group !== 'undefined' ? group : input.group;
    input.auction = typeof auction !== 'undefined' ? auction : input.auction;
    if (typeof input.group === 'undefined') {
      this.setState({ dd_loading: false });
      return;
    }
    let response = await getDashboardData(input);
    if (response.success) {
      let { data } = response;
      this.setState({
        active_auctions: data.active_auctions,
        active_bidders: data.active_bidders,
        total_bidders: data.total_bidders,
        maximum_bid_amount: data.maximum_bid_amount,
        total_amount: data.total_amount,
        auction_in_bidding: data.auction_in_bidding,
        total_bids: data.total_bids,
      });
      this.setState({ dd_loading: false });
    }
  }

  async loadAuctionsData() {
    this.setState({ is_loading_1: true });
    let auctions = this.state.auctions;
    const response = await getAuctionChartData('main');
    let data = response.data;
    if (response) {
      auctions.series = [data.active, data.upcoming, data.previous, data.featured, data.direct];
      this.setState({
        is_loading_1: false,
        auctions,
        main_auctions: auctions.series,
      });
    }
  }

  async loadCharityAuctionsData() {
    this.setState({ is_loading_2: true });
    let charity = this.state.charity;
    const response = await getAuctionChartData('charity');
    let data = response.data;
    if (response) {
      charity.series = [data.active, data.upcoming, data.previous, data.featured, data.direct];
      this.setState({
        is_loading_2: false,
        charity,
        charity_auctions: charity.series,
      });
    }
  }

  async loadUserChartData() {
    this.setState({ is_loading_3: true });
    let daily = this.state.daily;
    let monthly = this.state.monthly;
    const response = await getUserChartData();
    let data = response.data;
    if (response) {
      this.setState({ is_loading_3: false });
      daily.options = {
        chart: { id: 'chart-userdata' },
        xaxis: {
          categories: data.dates,
          labels: {
            rotate: -45,
            rotateAlways: true,
          },
        },
      };
      daily.series = [
        {
          name: 'Total Users',
          data: data.values,
        },
      ];

      monthly.options = {
        chart: { id: 'chart-userdata' },
        xaxis: {
          categories: data.months,
          labels: {
            rotate: -45,
            rotateAlways: true,
          },
        },
      };
      monthly.series = [
        {
          name: 'Total Users',
          data: data.month_values,
        },
      ];

      this.setState({ daily, monthly });
    }
  }

  async loadSalesChartData() {
    this.setState({ is_loading_4: true });
    let yearly = this.state.yearlySales;
    let monthly = this.state.monthlySales;
    const response = await getSalesChartData();
    let data = response.data;
    if (response) {
      this.setState({ is_loading_4: false });
      yearly.options = {
        chart: { id: 'chart-salesdata' },
        xaxis: {
          categories: data.years,
          labels: {
            rotate: -45,
            rotateAlways: true,
          },
        },
      };
      yearly.series = [
        {
          name: 'Total Sales',
          data: data.year_values,
        },
      ];

      monthly.options = {
        chart: { id: 'chart-salesdata' },
        xaxis: {
          categories: data.months,
          labels: {
            rotate: -45,
            rotateAlways: true,
          },
        },
      };
      monthly.series = [
        {
          name: 'Total Sales',
          data: data.month_values,
        },
      ];

      this.setState({ yearlySales: yearly, monthlySales: monthly });
    }
  }

  hideSideBar(is_side_bar) {
    this.setState({
      is_side_bar: is_side_bar,
    });
  }

  render() {
    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('auction_evaluation')} />
        <section className="sptb mt-3 ">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.is_side_bar && <SideBar />}
              </div>
              <div
                className={
                  this.state.is_side_bar
                    ? 'col-xl-12 col-lg-12 col-md-12 dash-container'
                    : 'col-xl-9 col-lg-12 col-md-12 dash-container'
                }
              >
                

                <div class="rounded-4 hide_div mb-3">
                  <div class="py-3">
                    <div class="p-2 user-brd rounded-4">
                      <div class="grid_container ">

                        <ProjectCard
                          className="approved"
                          icon={ShieldCheck}
                          title={i18n.t('active_auctions')}
                          value={this.state.main_auctions[0] || 0}
                        />

                        <ProjectCard
                          className="pending"
                          icon={Clock}
                          title={i18n.t('upcoming_auctions')}
                          value={this.state.main_auctions[1] || 0}
                        />

                        <ProjectCard
                          className="fundAdded"
                          icon={CalendarCheck}
                          title={i18n.t('previous_auctions')}
                          value={this.state.main_auctions[2] || 0}
                        />

                        <ProjectCard
                          className="all"
                          icon={Clock}
                          title={i18n.t('featured_auctions')}
                          value={this.state.main_auctions[3] || 0}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card auction-dashboard-card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <i className="fas fa-chart-pie me-2 text-primary"></i>
                          <h3 className="card-title mb-0 fw-bold">{i18n.t('auctions')}</h3>
                        </div>
                        <div className="total-auctions-badge">
                          <span className="btn btn-primary-custom">
                            Total: {this.state.main_auctions.reduce((a, b) => a + b, 0)}
                          </span>
                        </div>
                      </div>

                      <div className="card-body">
                        {this.state.is_loading_1 && (
                          <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2 text-muted">Loading auction data...</p>
                          </div>
                        )}

                        {!this.state.is_loading_1 && (
                          <div className="row align-items-center">
                            {/* Chart Section */}
                            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
                              <div className="chart-container position-relative">
                                <Chart
                                  options={{
                                    ...this.state.auctions.options,
                                    chart: {
                                      ...this.state.auctions.options.chart,
                                      toolbar: { show: false }
                                    },
                                    legend: { show: false },
                                    dataLabels: {
                                      enabled: true,
                                      formatter: function (val) {
                                        return Math.round(val) + '%'
                                      },
                                      dropShadow: { enabled: false }
                                    },
                                    plotOptions: {
                                      pie: {
                                        donut: {
                                          size: '65%',
                                          labels: {
                                            show: true,
                                            total: {
                                              show: true,
                                              label: 'Total Auctions',
                                              color: '#6c757d',
                                              fontSize: '14px',
                                              fontWeight: 600
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }}
                                  series={this.state.auctions.series}
                                  type="donut"
                                  height={320}
                                />
                              </div>
                            </div>

                            {/* Legend & Actions Section */}
                            <div className="col-lg-6 col-md-12">
                              <div className="auction-stats-container">
                                <h5 className="stats-title mb-4">Auction Status</h5>

                                <div className="legend-container mb-4">
                                  {[
                                    { label: 'Active', color: '#008ffb', count: this.state.main_auctions[0] },
                                    { label: 'Upcoming', color: '#00e396', count: this.state.main_auctions[1] },
                                    { label: 'Previous', color: '#fdb01a', count: this.state.main_auctions[2] },
                                    { label: 'Featured', color: '#ff4560', count: this.state.main_auctions[3] },
                                    { label: 'Direct', color: '#765dcf', count: this.state.main_auctions[4] }
                                  ].map((item, index) => (
                                    <div key={index} className="legend-item d-flex align-items-center justify-content-between mb-3 p-2 rounded hover-effect">
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="color-indicator me-3"
                                          style={{ backgroundColor: item.color }}
                                        ></div>
                                        <span className="legend-label fw-medium">{item.label}</span>
                                      </div>
                                      <span className="legend-count badge bg-light text-dark">{item.count}</span>
                                    </div>
                                  ))}
                                </div>

                                {/* Action Buttons */}
                                <div className="action-buttons mt-4">
                                  {user.role !== 'A' ? (
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-start">
                                      {[
                                        { label: 'Active', color: '#008ffb', count: this.state.main_auctions[0] },
                                        { label: 'Upcoming', color: '#00e396', count: this.state.main_auctions[1] },
                                        { label: 'Previous', color: '#fdb01a', count: this.state.main_auctions[2] },
                                        { label: 'Featured', color: '#ff4560', count: this.state.main_auctions[3] },
                                        { label: 'Direct', color: '#765dcf', count: this.state.main_auctions[4] }
                                      ].map((item, index) => (
                                        <button
                                          key={index}
                                          className="btn btn-sm me-2 mb-2 auction-action-btn"
                                          style={{
                                            backgroundColor: item.color,
                                            color: '#FFF',
                                            border: 'none',
                                            borderRadius: '20px',
                                            padding: '8px 16px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            minWidth: '100px'
                                          }}
                                        >
                                          {item.label}: {item.count}
                                        </button>
                                      ))}
                                    </div>
                                  ) : (
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-start">
                                      {[
                                        { label: 'Active', color: '#008ffb', count: this.state.main_auctions[0], link: 'auctions_list?type=active&section=main' },
                                        { label: 'Upcoming', color: '#00e396', count: this.state.main_auctions[1], link: 'auctions_list?type=upcoming&section=main' },
                                        { label: 'Previous', color: '#fdb01a', count: this.state.main_auctions[2], link: 'auctions_list?type=previous&section=main' },
                                        { label: 'Featured', color: '#ff4560', count: this.state.main_auctions[3], link: 'auctions_list?type=featured&section=main' },
                                        { label: 'Direct', color: '#765dcf', count: this.state.main_auctions[4], link: 'auctions_list?type=direct&section=main' }
                                      ].map((item, index) => (
                                        <a
                                          key={index}
                                          href={item.link}
                                          className="btn btn-sm me-2 mb-2 auction-action-btn"
                                          style={{
                                            backgroundColor: item.color,
                                            color: '#FFF',
                                            border: 'none',
                                            borderRadius: '20px',
                                            padding: '4px 8px',
                                            fontSize: '0.6rem',
                                            fontWeight: '600',
                                            minWidth: '20px',
                                            textDecoration: 'none',
                                            display: 'inline-block',
                                            textAlign: 'center'
                                          }}
                                          onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = 'none';
                                          }}
                                        >
                                          {item.label}: {item.count}
                                        </a>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
